import api from "../../../api";

const API_URL = "/crm/type-units"; // base url, tanpa localhost jika pakai proxy

export async function getTypeUnits() {
  const res = await api.get(API_URL);
  return res.data;
}

export async function getTypeUnit(id) {
  const res = await api.get(`${API_URL}/${id}`);
  return res.data;
}

export async function createTypeUnit(data) {
  const res = await api.post(API_URL, data);
  return res.data;
}

export async function updateTypeUnit(id, data) {
  const res = await api.put(`${API_URL}/${id}`, data);
  return res.data;
}

export async function deleteTypeUnit(id) {
  return api.delete(`${API_URL}/${id}`);
} 